import { useProductPageContext } from "../../context/productPage.context";
import { BrandLogoComponent } from "./brandLogo.component";

const BrandLogo = () => {
    const {
        product: { brand },
        brandPagePath
    } = useProductPageContext();

    return (
        <BrandLogoComponent
            brand={brand}
            brandPagePath={brandPagePath}
        />
    );
};

export { BrandLogo };
